import {observable, action, runInAction} from 'mobx'
import {message} from 'antd'
import {json} from '../../../../utils/ajax'
import scrollIntoView from 'scroll-into-view';
import {setStore} from "../../../../utils/Utils";

class hoursHotspotManagerStore {

    @observable loading
    @observable carseries
    @observable carSysId
    @observable catalog
    @observable catalogId
    @observable contents
    @observable imgUrl
    @observable coordiante
    @observable data
    @observable rowId
    @observable rowData

    constructor() {
        this.loading = false
        this.carseries = []
        this.carSysId = ''
        this.catalog = []
        this.catalogId = ''
        this.contents = []
        this.imgUrl = ''
        this.coordiante = null
        this.data = ''
        this.rowId = ''
        this.rowData = {}
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 初始化车系
     */
    @action
    initCarseries = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/carseriesCatalog/list`, {
            size: 100
        })
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.carseries = res.content
            this.loading = false
        })
    }

    /**
     * 取车系ID
     */
    @action
    getCarSysId = (value) => {
        runInAction(() => {
            this.carSysId = value;
        })
    }

    /**
     * 目录树
     */
    @action
    initDirectory = async (value) => {
        runInAction(() => {
            this.contents = []
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/list?carseriesId=${value}`)
        if (res.length === 0) {
            message.warning('该车系没有目录！')
            runInAction(() => {
                this.catalog = [];
                this.loading = false
            })
            return null
        }
        runInAction(() => {
            this.catalog = res
            this.loading = false
            this.tableHandleScroll()
        })
    }

    /**
     * 获取到目录树ID
     */
    @action
    stlcontent = (catalogId) => {
        runInAction(() => {
            this.catalogId = catalogId
        })
    }

    /**
     * 显示内容
     */
    @action
    loadContents = async () => {
        runInAction(() => {
            this.loading = true
            this.contents = []
            this.coordiante = null
        })
        const res2 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/catalog/selectLevel?id=${this.catalogId}`)
        if (res2 && res2.status === 0) {
            return
        }
        runInAction(() => {
            this.data = res2.data
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/list?catalogId=${this.catalogId}`)
        if (res && res.status === 0) {
            return
        }
        const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/contentImg/catalogId/${this.catalogId}`)
        runInAction(() => {
            this.contents = res
            this.imgUrl = res1.image
            this.loading = false
        })
    }

    /**
     * 设置点击位置
     */
    @action
    setPosition = (position) => {
        runInAction(() => {
            this.coordiante = position
        })
    }

    /**
     * 新增热点
     */
    @action
    saveHotsopt = async (id) => {
        this.rowId = id
        this.loading = true
        if (this.coordiante !== null) {
            const res1 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/id/${id}`)
            if (res1 && res1.status === 0) {
                return
            }
            const res2 = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/hotspot/id/${id}`)
            if (res2.xaxis === null) {
                let data = {
                    catalogId: this.catalogId,
                    contentId: id,
                    contentName: res1.name,
                    contentTimeCodeComplete: res1.timeCodeComplete,
                    contentTimeCodeSupplement: res1.timeCodeSupplement
                }
                const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/hotspot/create?XAxis=${this.coordiante.left}&YAxis=${this.coordiante.top}`, data)
                if (res && res.status === 0) {
                    message.error('新增失败')
                    this.loading = false
                    return
                }
                let state = res1.state ? 0 : 1;
                await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/id/${id}/state/${state}`)
                runInAction(() => {
                    this.loading = false
                })
                this.loadContents(this.catalogId)
                this.initDirectory(this.carSysId)
            } else {
                runInAction(() => {
                    message.warning('该热点已维护，请先清除在进行添加!')
                    this.loading = false
                })
            }
        } else {
            runInAction(() => {
                message.warning('请先选择热点，在添加!')
                this.loading = false
            })
        }
    }

    /**
     * 回显热点
     */
    @action
    echoHot = async (value) => {
        this.rowId = value.id
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/hotspot/id/${value.id}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            if (res.xaxis === null) {
                message.warning('该条数据没有热点，请添加热点!')
                this.coordiante === null //eslint-disable-line
            } else {
                this.coordiante = {
                    left: res.xaxis,
                    top: res.yaxis
                }
            }
            this.loading = false
        })
    }

    /**
     * 清除热点
     */
    @action
    removeHot = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        if (this.coordiante !== null) {
            const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/hotspot/delete?id=${id}`)
            if (res && res.status >= 400) {
                return
            }
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/id/${id}/state/${0}`)
            runInAction(() => {
                message.success('清除成功')
                this.loading = false
            })
            this.loadContents(this.catalogId)
            this.initDirectory(this.carSysId)
        } else {
            runInAction(() => {
                message.warning('该条数据没有热点!')
                this.loading = false
            })
        }
    }

    /**
     * 初始化页面
     */
    @action
    emptyPage = () => {
        runInAction(() => {
            this.contents = []
            this.catalog = []
            this.data = ''
            this.coordiante = null
        })
    }

    /**
     * 批量删除
     */
    @action
    batchDelete = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/hotspot/batchDelete?id=${this.catalogId}`)
        if (res && res.status >= 400) {
            return
        }
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/hoursManual/content/batchUpdateState/id/${this.catalogId}`)
        runInAction(() => {
            message.success('清除成功')
            this.loading = false
        })
        this.loadContents(this.catalogId)
        this.initDirectory(this.carSysId)
    }

    //点击滚动
    tableHandleScroll = () => {
        setTimeout(function () {
            scrollIntoView(document.querySelector('.row-select'), {
                behavior: 'smooth', block: 'start',
                align: {
                    top: 0,
                },
            });
        }, 500);
    }
}

export default new hoursHotspotManagerStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/HoursManual/HoursHotspotManager/store.js